var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-flex flex-column justify-content-around",attrs:{"fluid":""}},[_c('TheHeaderSection'),_c('TheMainSection'),_c('TheFooterSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }